import { render, staticRenderFns } from "./frontDatosPersonalesForm.vue?vue&type=template&id=71f3cef8&scoped=true&"
import script from "./frontDatosPersonalesForm.vue?vue&type=script&lang=js&"
export * from "./frontDatosPersonalesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f3cef8",
  null
  
)

export default component.exports